import { Injectable } from "@angular/core";
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';
import { Headers, RequestOptions } from '@angular/http';

import { BaseWebService } from '../../shared/services/base-web.service';
import 'rxjs/add/observable/throw';

@Injectable()
export class TCDashboardService {
    from_date: any;
    to_date: any;

    constructor(private _baseWebService: BaseWebService
    ) { }

    /**
         * Function for get communication history
         */
    followUpHistory(id: any) {
        return this._baseWebService.request("v1/followup_history/" + id + "/", "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    followUpVCHistory(id: any) {
        return this._baseWebService.request("v1/va/vc_followup/" + id + "/history/", "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    parentFollowUpHistory(id: any) {
        return this._baseWebService.request("v1/parent_relapse_communications/" + id + "/history/", "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    patientFollowUpHistory(id: any) {
        return this._baseWebService.request("v1/patient_relapse_communications/" + id + "/history/", "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    // get goals report data
    getGoalsReportData() {
        return this._baseWebService.request("v1/report/goal/?date_from=" + this.from_date + "&date_to=" + this.to_date, "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    getRecentlyExpiredQuotes(searchValue: any) {
        let searchKey = "";
        if (searchValue)
            searchKey = "&search=" + searchValue;
		
        return this._baseWebService.request("v1/treatment_plans_expired/?limit=6&offset=0" + searchKey, "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    reviveService(id: any) {
        let url = "v1/treatment_plan/" + id + "/revive/";
        return this._baseWebService.request(url, "put")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    // get stastics report data
    getStatiticsReportData() {
        return this._baseWebService.request("v1/report/overall_statics/?date_from=" + this.from_date + "&date_to=" + this.to_date, "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    followUpCommunicationService(searchValue: any) {
        let searchKey = "";
        if (searchValue)
            searchKey = "&search=" + searchValue;
		
        return this._baseWebService.request("v1/followup_communications/?limit=6&offset=0&dashboard=true" + searchKey, "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    virtualFollowUpCommunicationService(searchValue: any) {
        let searchKey = "";
        if (searchValue)
            searchKey = "&search=" + searchValue;
		
        return this._baseWebService.request("v1/va/vc_followup_list/?limit=6&offset=0&dashboard=true" + searchKey, "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    parentFollowUpCommunicationService(searchValue: any) {
        let searchKey = "";
        if (searchValue)
            searchKey = "&search=" + searchValue;
		
        return this._baseWebService.request("v1/parent_relapse_communications/?limit=6&offset=0&dashboard=true" + searchKey, "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    patientFollowUpCommunicationService(searchValue: any) {
        let searchKey = "";
        if (searchValue)
            searchKey = "&search=" + searchValue;
		
        return this._baseWebService.request("v1/patient_relapse_communications/?limit=6&offset=0&dashboard=true" + searchKey, "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    patientRefferalListService(searchValue: any) {
        let searchKey = "";
        if (searchValue)
            searchKey = "&search=" + searchValue;
		
        return this._baseWebService.request("v1/patient_referrals/?limit=6&offset=0&pending=true" + searchKey, "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    tcDashBoardService(fromDate: any, toDate: any, timeFrame: any) {
        this.from_date = fromDate;
        this.to_date = toDate;
        return this._baseWebService.request("v1/dashboard_tc/?from_date=" + this.from_date + "&to_date=" + this.to_date + "&time_frame=" + timeFrame, "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    recentPatientFilesService(searchValue: any) {
        let searchKey = "";
        if (searchValue)
            searchKey = "&search=" + searchValue;
		
        return this._baseWebService.request("v1/patient_files/?limit=6&offset=0" + searchKey, "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    contactFollowUp(contactInfo: any) {
        var data: any = {};
        data['body'] = {};
        data.body['method'] = contactInfo.method;
        if (contactInfo.customMessage)
            data.body['message'] = contactInfo.customMessage;

        return this._baseWebService.request("v1/followup_communications/" + contactInfo.currentPerson.id + "/contact/", "post", data)
            .map((res: any) => res)
            .catch(this.handleError);
    }

    contactVCFollowUp(contactInfo: any) {
        var data: any = {};
        data['body'] = {};
        data.body['method'] = contactInfo.method;
        if (contactInfo.customMessage)
            data.body['message'] = contactInfo.customMessage;

        return this._baseWebService.request("v1/va/vc_followup/" + contactInfo.currentPerson.id + "/contact/", "post", data)
            .map((res: any) => res)
            .catch(this.handleError);
    }

    contactParentFollowUp(contactInfo: any) {
        var data: any = {};
        data['body'] = {};
        data.body['method'] = contactInfo.method;
        if (contactInfo.customMessage)
            data.body['message'] = contactInfo.customMessage;

        return this._baseWebService.request("v1/parent_relapse_communications/" + contactInfo.currentPerson.id + "/contact/", "post", data)
            .map((res: any) => res)
            .catch(this.handleError);
    }

    contactPatientFollowUp(contactInfo: any) {
        var data: any = {};
        data['body'] = {};
        data.body['method'] = contactInfo.method;
        if (contactInfo.customMessage)
            data.body['message'] = contactInfo.customMessage;

        return this._baseWebService.request("v1/patient_relapse_communications/" + contactInfo.currentPerson.id + "/contact/", "post", data)
            .map((res: any) => res)
            .catch(this.handleError);
    }

    getEmailFollowUp(contactInfo: any) {
        var data: any = {};
        data['body'] = {};
        data.body['method'] = contactInfo.method;
        if (contactInfo.customMessage)
            data.body['message'] = contactInfo.customMessage;

        return this._baseWebService.request("v1/followup_communications/" + contactInfo.currentPerson.id + "/contact/", "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    getEmailVCFollowUp(contactInfo: any) {
        var data: any = {};
        data['body'] = {};
        data.body['method'] = contactInfo.method;
        if (contactInfo.customMessage)
            data.body['message'] = contactInfo.customMessage;

        return this._baseWebService.request("v1/va/vc_followup/" + contactInfo.currentPerson.id + "/contact/", "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    getEmailParentFollowUp(contactInfo: any) {
        var data: any = {};
        data['body'] = {};
        data.body['method'] = contactInfo.method;
        if (contactInfo.customMessage)
            data.body['message'] = contactInfo.customMessage;
        return this._baseWebService.request("v1/parent_relapse_communications/"+ contactInfo.currentPerson.id +"/contact/", "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    getEmailPatientFollowUp(contactInfo: any) {
        var data: any = {};
        data['body'] = {};
        data.body['method'] = contactInfo.method;
        if (contactInfo.customMessage)
            data.body['message'] = contactInfo.customMessage;
        return this._baseWebService.request("v1/patient_relapse_communications/"+ contactInfo.currentPerson.id +"/contact/", "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    getEmailRefPatient(contactInfo: any) {
        var data: any = {};
        data['body'] = {};
        data.body['method'] = contactInfo.method;
        if (contactInfo.customMessage)
            data.body['message'] = contactInfo.customMessage;

        return this._baseWebService.request("v1/patient_referral/" + contactInfo.currentPerson.id + "/contact/", "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    contactRefPatient(contactInfo: any) {
        var data: any = {};
        data['body'] = {};
        data.body['method'] = contactInfo.method;
        if (contactInfo.customMessage)
            data.body['message'] = contactInfo.customMessage;

        return this._baseWebService.request("v1/patient_referral/" + contactInfo.currentPerson.id + "/contact/", "post", data)
            .map((res: any) => res)
            .catch(this.handleError);
    }

    getGraphData = (apiUrl: string) => {
        return this._baseWebService.request(apiUrl, "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    followUpReferalHistory(id: any){
        return this._baseWebService.request("v1/referral_followup_history/" + id + "/", "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    getTimeFrames = () => {
        return this._baseWebService.request("v1/timeframes/", "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    /**
     * Function for cancel tracking
     */
    cancelTracking(id: any) {
        const data: any = {};
        data.body = { is_in_follow_up: false };
        return this._baseWebService.request("v1/followup_communications/" + id + "/untrack/", "put", data)
            .map((res: any) => res)
            .catch(this.handleError);
    }

    /**
     * Function for cancel virtual tracking
     */
    cancelVirtualTracking(id: any) {
        const data: any = {};
        data.body = { is_in_follow_up: false };
        return this._baseWebService.request("v1/va/virtual_consultation/" + id + '/', "delete", data)
            .map((res: any) => res)
            .catch(this.handleError);
    }


    /**
     * Service Function Delete referral patient
     */

    deleteRefPatientService(id: any) {
        return this._baseWebService.request("v1/patient_referral/" + id + "/", "delete")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    /**
     * Function for cancel tracking
     */
    deleteRelapseService(id: any, type: string) {
        const data: any = {};
        data.body = {is_in_follow_up: false};
        let url = "v1/" + type + "/" + id + "/untrack/";
        return this._baseWebService.request(url, "put", data)
            .map((res: any) => res)
            .catch(this.handleError);
    }

    /**
     * Function to get patient file history from api.
     * @param  {any} id contains patient id.
     */
    getPatientFile(id: any) {
        return this._baseWebService.request("v1/patient_file/" + id + "/", "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    // check if vc enabled
    getUserStatus() {
        return this._baseWebService.request("v1/va/user_status/", "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    /**
     * Function to get tx plan from api.
     * @param  {any} id contains tx plan id.
     */
    getTreatmentPlan(id: any) {
        return this._baseWebService.request("v1/treatment_plan/" + id + "/", "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    // update virtual plan to tx plan on present
    virtualPlanPresent(id: any) {
        return this._baseWebService.request('v1/va/treatment_plan/' + id + '/present/', "post")
            .map(res => res)
            .catch(this.handleError);
    }

    sendHealthHistoryForm(id: any, present?: boolean) {
        let query = "v1/patient_file/" + id + "/health_history/";
        if (present) {
            query = query + '?present_now=true';
        }
        return this._baseWebService.request(query, "post")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    postponeFollowup(postponeData: any, id: any) {
        const data: any = {};
        data.body = postponeData;
        return this._baseWebService.request("v1/followup_communications/" + id + "/postpone/", "put", data)
            .map((res: any) => res)
            .catch(this.handleError);
    }

    /**
    * Function to get patient file history from api.
    * @param  {any} id contains patient id.
    */
    fetchActivePatientFileTxPlanStatus(id: any) {
        return this._baseWebService.request("v1/patient_file/" + id + "/active_tx_plan/", "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    /**
      * Function for handling service call errors
      * @param  {Response|any} error contains error data
      */
    handleError(error: Response | any) {
        return Observable.throw(error);
    }
}
